<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="投标"
    width="500px"
  >
    <!-- 员工工资输入框 -->
    <div>
      <el-form
        :model="formData"
        :rules="rules"
        ref="form"
        label-width="100px"
      >
        <el-form-item label="员工工资" prop="bid_wages">
          <el-input v-model="formData.bid_wages"></el-input>
        </el-form-item>
        <el-form-item label="佣金" prop="bid_commission">
          <el-input v-model="formData.bid_commission"></el-input>
        </el-form-item>

        <el-form-item label="上传附件" prop="bid_annex_url">
            <el-upload class="upload-demo" drag :action="uploadFileUrl" :file-list="fileList" :limit="1" :on-error="handleUploadError" :on-exceed="handleExceed" :on-success="handleUploadSuccess">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                <em>点击上传</em>
                <!-- <div class="el-upload__tip" slot="tip">
                  只能上传jpg/png文件，且不超过500kb
                </div> -->
              </div>
            </el-upload>
        </el-form-item>
        <el-form-item label="备注" prop="remarks" >
          <el-input type="textarea" v-model="formData.remarks"></el-input>
        </el-form-item>
      </el-form>
    </div>
   
   
    <span slot="footer" class="dialog-footer">
      <el-button
        @click="submit"
        size="mini"
        style="background: #4d71d9; border: none; color: aliceblue"
        >确认投标</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import urlConfig from '@/api/config'
import { webCrowdBidAdd } from "@/api/director/package/index";

export default {
  data() {
    return {
      visible: false,
      
      uploadFileUrl: urlConfig.prod.baseURL + "/web/file/Upload", // 上传的图片服务器地址
      fileList: [],

      formData:{
        crowd_id:"",//众包id
        bid_wages:"",//员工工资

        bid_commission:"",//佣金

        remarks:"",//备注

        corpor_id:"",//社团id
        bid_annex_name:"",
        bid_annex_url:"",
      },
      rules: {
        bid_wages: [
          { required: true, message: "请输入员工工资", trigger: "blur" },
        ],
        bid_commission: [
          { required: true, message: "请输入佣金", trigger: "blur" },
        ],
        remarks:[
        { required: true, message: "请输入备注", trigger: "blur" },
        ],
        bid_annex_url:[
        { required: true, message: "请上传附件", trigger: "blur" },
        ]
      },
    };
  },
  methods: {
    handleClose(){
      this.visible = false;
    },
    init(crowd_id,corpor_id) {
      this.visible = true;
      this.formData.crowd_id=crowd_id;
      this.formData.corpor_id=corpor_id;
      //this.initComp();
    },
    submit() {
      
      var that=this;

     this.$refs["form"].validate((valid) => {
         if (valid) {
          webCrowdBidAdd(that.formData).then((response) => {
             console.log(response);
             if(response.code==200){
               this.$message({
                  message: "提交成功",
                  type: 'success'

               });
               that.$emit('refresh');
               that.visible = false;
             
             }else{
               this.$message({
                 message: response.msg?response.msg:"提交失败",
               });
             }
           });
         } 
       });


    },
    

    removeFile () {
      this.fileList = [];
      this.formData.bid_annex_url = '';
      this.formData.bid_annex_name = '';
    },


    // 文件个数超出
    handleExceed () {
      this.$message.error(`只允许上传单个文件`);
    },
    // 上传失败
    handleUploadError (err) {
      this.$message.error("上传失败, 请重试");
    },
    // 上传成功回调
    handleUploadSuccess (res, file) {
      console.log(res);
      this.formData.bid_annex_url = res.file;
      this.formData.bid_annex_name = res.filename;

      this.$message.success("上传成功");
      console.log(this.form2);

    },

    // 获取文件名称
    getFileName (name) {
      if (name.lastIndexOf("/") > -1) {
        return name.slice(name.lastIndexOf("/") + 1).toLowerCase();
      } else {
        return "";
      }
    },

  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  display: flex;
  background-color: #f4f6f8;
  border-radius: 10px 10px 0 0;
}

::v-deep .el-dialog--center {
  border-radius: 10px;
}

::v-deep .el-dialog__footer {
  margin-top: 25px;
  display: flex;
  justify-content: flex-end;
}

::v-deep .dialog-footer {
  ::v-deep .el-button--primary {
    background-color: #ff4e4e;
  }
}

::v-deep .el-dialog__body {
  padding: 25px 25px 0 25px;
}

</style>
